var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDisk = function SvgDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.99.783H.874v117.25h117.25V35.919L82.989.783ZM34.374 112.45V62.2h50.25v50.25h-50.25Zm78.167 0H90.208V56.616H28.792v55.834H6.458V6.367h74.22l31.864 31.864v74.219Z",
    fill: "#C5B27C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.042 67.783H39.96v5.583h39.083v-5.583Z",
    fill: "#C5B27C"
  })));
};
export default SvgDisk;